module.exports = __webpack_public_path__ + "static/the-world-without-us-9b7796cdf2d49089e95af34ddbdae6cb.jpg";